import React, { memo } from 'react';
import { TiltCard } from './ui/TiltCard';
import { Button } from './ui/Button';
import { PhoneOff, Clock, Ghost, Zap, DollarSign, Megaphone } from 'lucide-react';
import { motion } from 'framer-motion';
const problems = [{
  icon: PhoneOff,
  title: 'Missed Calls = Lost Revenue',
  impact: 'Average loss: £500-5,000 per missed call',
  desc: 'Every unanswered call is a customer choosing your competitor because you were too busy.'
}, {
  icon: Clock,
  title: 'Manual Tasks = Wasted Time',
  impact: "That's £50,000+ yearly in wasted labor",
  desc: 'Your team spends 20+ hours/week on repetitive work that software could do instantly.'
}, {
  icon: Ghost,
  title: 'No Online Presence',
  impact: "No website = You don't exist to them",
  desc: '80% of customers check websites before buying. Without one, you lose credibility and sales.'
}, {
  icon: Zap,
  title: 'Slow Response Time',
  impact: 'Your competitors are faster than you',
  desc: 'Leads contacted within 5 minutes are 100x more likely to convert. Speed is money.'
}, {
  icon: DollarSign,
  title: 'Inconsistent Follow-Up',
  impact: 'Manual follow-up fails 80% of the time',
  desc: '60% of sales require 5+ follow-ups. If you rely on memory, you are leaving money on the table.'
}, {
  icon: Megaphone,
  title: 'Work Smarter, Not Harder',
  impact: 'Burnout = Stagnant Growth',
  desc: 'Without automation, your business relies entirely on your physical presence to grow.'
}];
export function ProblemSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 md:py-24 gradient-section-warm relative overflow-hidden" data-id="element-325">
      <div className="container mx-auto px-4" data-id="element-326">
        <div className="text-center mb-10 md:mb-16 max-w-3xl mx-auto" data-id="element-327">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} viewport={{
          once: true
        }} className="inline-block mb-4" data-id="element-328">
            <div className="bg-primary/10 p-3 md:p-4 rounded-full border border-primary/20" data-id="element-329">
              <Clock className="w-6 h-6 md:w-8 md:h-8 text-primary" data-id="element-330" />
            </div>
          </motion.div>
          <h2 className="text-3xl md:text-5xl font-black text-black mb-3 md:mb-4" data-id="element-331">
            EVERY HOUR YOU WASTE IS{' '}
            <span className="text-primary border-b-4 border-primary" data-id="element-332">
              MONEY YOU LOSE
            </span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600" data-id="element-333">
            Manual work is silently draining your business.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-334">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: index * 0.1,
          ease: 'easeOut'
        }} viewport={{
          once: true
        }} data-id="element-335">
              <TiltCard className="h-full bg-white border border-gray-200 p-5 md:p-8 rounded-xl md:rounded-2xl group" data-id="element-336">
                <div className="mb-4 md:mb-6 relative" data-id="element-337">
                  <div className="absolute inset-0 bg-primary/10 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-338" />
                  <problem.icon className="w-10 h-10 md:w-12 md:h-12 text-primary relative z-10" data-id="element-339" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-black mb-1.5 md:mb-2" data-id="element-340">
                  {problem.title}
                </h3>
                <p className="text-primary font-semibold mb-3 md:mb-4 text-xs md:text-sm" data-id="element-341">
                  {problem.impact}
                </p>
                <p className="text-gray-600 text-xs md:text-sm leading-relaxed" data-id="element-342">
                  {problem.desc}
                </p>
              </TiltCard>
            </motion.div>)}
        </div>

        <div className="mt-10 md:mt-16 text-center" data-id="element-343">
          <h3 className="text-xl md:text-2xl font-bold text-black mb-4 md:mb-6" data-id="element-344">
            Stop working in your business. Start working on it.
          </h3>
          <Button size="lg" className="px-8 md:px-12" onClick={scrollToContact} data-id="element-345">
            START SAVING TIME TODAY
          </Button>
        </div>
      </div>
    </section>;
}